import React, {lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import demoRoutes from "./routers/demoRoutes";
import ErrorPage from "../views/error";
import { dashboardRoutes } from "./routers/dashboardRoutes";
import { isAuthenticated, isUnAuthenticated } from "../helper";
// import Landing from "../views/landing";
import { authenticationRoutes } from "./routers/authenticationRoutes";
import AuthLayout from "../layouts/authentication";
import { Routes } from "./routes";
import DashboardLayout from "layouts/dashboard";
import RouteProtection from "./guards/routeProtection";
import { onboardingRoutes } from "./routers/onboardingRoutes";
import OnboardingLayout from "layouts/onboarding";
import Landing from "views/landing";
import { store } from "store";
const AuthorizeEmail = lazy(() => import('views/registration/authorizeEmail'));

const routes = createBrowserRouter([
  {
    path: Routes.base,
    element: <Landing />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.authorizeEmail,
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <AuthorizeEmail/>
      },
    ]
  },
  {
    path: Routes.auth,
    element: (
      <RouteProtection
        redirect={Routes.dashboard}
        validations={[isUnAuthenticated]}
      >
        <AuthLayout />
      </RouteProtection>
    ),
    errorElement: <ErrorPage />,
    children: [...authenticationRoutes()],
  },
  {
    path: Routes.onboarding,
    errorElement: <ErrorPage />,
    element: (
      <RouteProtection 
        redirect={Routes.login}
        permissionsFunction={() => {
          return store.getState().user.merchant?.user.member.role.name === "OWNER";
        }}
        validations={[isAuthenticated]}
      >
        <OnboardingLayout />
      </RouteProtection>
    ),
    children: [...onboardingRoutes()],
  },
  {
    path: Routes.app,
    errorElement: <ErrorPage />,
    element: (
      <RouteProtection
        redirect={Routes.login}
        validations={[isAuthenticated]}
      >
        <DashboardLayout />
      </RouteProtection>
    ),
    children: [...dashboardRoutes()],
  },
  ...demoRoutes,
]);

export default routes;
